export const money = (n, symbol = "\u20b9") => `${symbol}${Number(n || 0).toFixed(2)}`;

export const resolveUrl = (u) =>
  !u ? "" : (u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);


export const fmtDate = (iso) => {
  try { return new Date(iso).toLocaleString(); } catch { return iso; }
};
export const fmtTime = (iso) => {
  try { return new Date(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }); } catch { return ""; }
};
